import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = (data) => {
  return request.put(
    'Acceptance/update_record',
    data,
    'Не удалось изменить данные',
    'Error'
  );
};

export const useUpdateRegistration = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
